import { faker } from '@faker-js/faker';

import type { ToggleMfaPostResponse } from '../types/ToggleMfaPostResponse';

export function createToggleMfaPostResponse(
  data: NonNullable<Partial<ToggleMfaPostResponse>> = {}
): NonNullable<ToggleMfaPostResponse> {
  return {
    ...{
      data: { secret_code: faker.string.alpha() },
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
